var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"40px"}},[_c('v-file-input',{staticStyle:{"border-radius":"20px"},attrs:{"outlined":"","dense":"","background-color":"#ffffff","label":_vm.label},on:{"change":_vm.uploadFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }